import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyStatusPayload {
  accountId: string;
  customerId: string;
}

export interface PasskeyStatusState {
  loading: boolean;
  isRegistered: boolean | null;
  error: any | null;
}

const initialState: PasskeyStatusState = {
  loading: false,
  isRegistered: null,
  error: null,
};

const passkeyStatusSlice = createSlice({
  name: 'passkeyStatus',
  initialState,
  reducers: {
    passkeyStatusRequest(state, _action: PayloadAction<PasskeyStatusPayload>) {
      state.loading = true;
      state.error = null;
    },
    passkeyStatusSuccess(state, action: PayloadAction<boolean>) {
      state.loading = false;
      state.isRegistered = action.payload;
      state.error = null;
    },
    passkeyStatusFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.isRegistered = null;
      state.error = action.payload;
    },
    resetPasskeyStatus() {
      return initialState;
    },
  },
});

export const {
  passkeyStatusRequest,
  passkeyStatusSuccess,
  passkeyStatusFailed,
  resetPasskeyStatus,
} = passkeyStatusSlice.actions;

export default passkeyStatusSlice.reducer;
